module.exports = __webpack_public_path__ + "assets/img/IMG025.58fe9b33.png";